<template>
    <Layout @filter="handleFilter">

        <div class="view-list">

            <div class="view-list-inner">
                <section class="fieldset">

                    <ConfigurationItem v-for="configuration in validConfigurations"
                                       :key="configuration.id"
                                       :infos="configuration.plugin"
                                       :provider="getProvider(configuration.plugin.providerId)"
                                       :configuration="configuration"
                                       :isActive="configuration.is_active"
                                       :isFinalized="configuration.is_finalized"
                                       @itemAction="handleItemAction"
                    ></ConfigurationItem>
                </section>
            </div>
        </div>
        <div slot="toolbar">

            <Btn :class="'primary pull-right mobile-block'" v-can="'admin-manage-plugins'" @click.native="handleNew">
                <font-awesome-icon icon="plus"/>
                Ajouter un connecteur
            </Btn>
        </div>
    </Layout>
</template>

<script>
    //import Component from 'path/to/component'

    import {mapGetters, mapMutations, mapActions} from 'vuex'

    import Layout from '@l/BaseWithToolbar'

    import ConfigurationItem from '@c/plugins/ConfigurationItem'

    import _find from 'lodash/find'


    export default {
        beforeCreate: function () {


        },
        beforeDestroy: function () {

        },
        beforeMount: function () {


        },
        beforeUpdate: function () {

        },
        components: {
            Layout,
            ConfigurationItem
        },
        computed: {
            ...mapGetters({
                providers: 'Plugins/providers',
                configurations: 'Plugins/configurations',
            }),

            validConfigurations(){
                return this.configurations.filter(item => {
                    return item.plugin
                })
            }
        },
        created: function () {

        },
        data() {
            return {}
        },
        destroyed: function () {

        },
        methods: {
            ...mapMutations({
                showLoading: 'UI/showLoading',
                showModal: 'UI/showModal',
                setModalParams: 'UI/setModalParams',

            }),
            ...mapActions({
                fetchConfigurations: 'Plugins/fetchConfigurations'
            }),

            getProvider(providerId) {
                return _find(this.providers, {id: providerId})
            },

            handleFilter(){

            },

            handleNew(){
                this.$router.push({name: 'pluginsLibrary'});
            },

            loadData(){
                this.fetchConfigurations()
                    .then(() => {
                        this.showLoading(false);
                    })
            },
            handleItemAction(){
                this.loadData()
            }
        },
        mounted: function () {

            this.$store.commit('UI/viewTitle', this.$i18n.t('plugins.titles.configurations'))
            this.$store.commit('UI/backAction', null)

            this.loadData()

        },
        name: '',
        props: {},
        updated: function () {

        },
        watch: {}
    }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/plugins/List.vue